import { IKnmFormRenderProps } from 'KnmPackage/MainModule/components/KnmForm';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';

export const getFormStateValues = (formInstance: IKnmFormRenderProps['form'] | undefined): IKnmForm | undefined =>
  formInstance?.getState().values;
export const getFormStateTypeCode = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.type?.code;
export const getFormStateStartDate = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.startDate;
export const getFormStateStopDate = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.stopDate;
export const getFormStateDurationDays = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.durationDays;
export const getFormStateDurationHours = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.durationHours;
export const getFormStateEvents = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.events;
export const getFormStateCollaboratingOrganizations = (formInstance: IKnmFormRenderProps['form'] | undefined) =>
  getFormStateValues(formInstance)?.collaboratingOrganizationsErknm;
